import React from "react";
import classes from "./InputsLogin.css";
// Libraries
import { PropTypes } from "prop-types";

const InputsLogin = (props) => {
  const { value, isPassword, placeholder, onChange, marginBottom = 0 } = props;
  return (
    <input
      style={{ marginBottom }}
      className={classes.Input}
      onChange={(event) => onChange(event.target.value)}
      {...{ value, placeholder }}
      type={isPassword ? "password" : "none"}
      autoComplete="on"
    />
  );
};

InputsLogin.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isPassword: PropTypes.bool.isRequired,
  marginBottom: PropTypes.number,
  placeholder: PropTypes.string.isRequired,
};

export default InputsLogin;



// WEBPACK FOOTER //
// ./src/Components/Inputs/Login/InputsLogin.js